import React, { useEffect, useState } from 'react'
import { Field, connect } from 'formik'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Checkbox } from '@local/do-secundo-form'
import { Dollars } from '@local/do-secundo-dollars'
import { Fieldset } from '@local/do-secundo-fieldset'
import { TermsModal, TFG } from '@local/do-secundo-terms-modal'
import { InfoIcon } from '@toasttab/buffet-pui-icons'
import styles from './RoundUpForCharity.module.css'

export const Component = connect(
  ({
    cart,
    campaignName = '',
    campaignDescription = '',
    campaignLogoURL = '',
    tip = 0,
    setFieldValue
  }) => {
    const orderTotal = cart.order.total || 0
    const serverTip = cart.order.tip || 0
    const roundUpValue = parseFloat(
      (
        1.0 -
        ((parseFloat(orderTotal - serverTip + tip) * 100) % 100) / 100
      ).toFixed(2)
    )
    const [shouldShowTerms, editShowTerms] = useState(false)

    useEffect(() => {
      setFieldValue('roundUpAmount', roundUpValue)
    }, [roundUpValue, setFieldValue])

    const Label = () => (
      <span>
        <span className={'flex items-center'}>
          Round up and give <Dollars amount={roundUpValue} />
          <button
            data-testid='tfg-terms-button'
            className={styles.infoButton}
            onClick={() => editShowTerms(!shouldShowTerms)}
            type='button'
          >
            <span className='flex'>
              <InfoIcon className={styles.infoImage} />
            </span>
          </button>
        </span>
      </span>
    )

    return (
      <>
        {shouldShowTerms && (
          <TermsModal onClose={() => editShowTerms(false)} terms={TFG} />
        )}
        <Fieldset
          label='Round Up & Give'
          collapsable
          id='roundup_fields'
          data-testid='collapsible-roundup-header'
        >
          <div className={styles.restaurantContent}>
            {campaignName && (
              <div className={styles.leftColumn}>
                {campaignName && (
                  <div
                    className={styles.heading}
                    data-testid='name-of-campaign'
                  >
                    {campaignName}
                  </div>
                )}
                {campaignDescription && (
                  <div
                    className={styles.description}
                    data-testid='desc-of-campaign'
                  >
                    {campaignDescription}
                  </div>
                )}
              </div>
            )}
            {campaignLogoURL && (
              <div
                className={cx(styles.rightColumn, 'bg-cover', 'bg-center')}
                data-testid='logo-of-campaign'
                style={{ backgroundImage: `url(${campaignLogoURL})` }}
              />
            )}
          </div>
          <div>
            <Field
              data-testid='roundup-checkbox'
              component={Checkbox}
              name='isRoundUpForCharity'
              id='isRoundUpForCharity'
              label={<Label />}
            />
            <Field
              data-testid='roundup-amount'
              type='hidden'
              name='roundUpAmount'
              id='roundUpAmount'
            />
          </div>
        </Fieldset>
      </>
    )
  }
)

export const getInitialValues = () => ({})

export const getArgsForSubmit = ({ values, cart }) => {
  const { tfgConfig } = cart.restaurant
  const active = tfgConfig ? tfgConfig.active : false
  const finalRoundUpAmount = (active && parseFloat(values.roundUpAmount)) || 0
  const isRoundUpEnabled =
    active && values.isRoundUpForCharity ? values.isRoundUpForCharity : false
  return {
    tfgInput: {
      roundUpEnabled: isRoundUpEnabled,
      estimatedRoundUpValue: (isRoundUpEnabled && finalRoundUpAmount) || 0
    }
  }
}

export const getValidationSchema = () => ({})

Component.propTypes = {
  cart: PropTypes.object.isRequired,
  campaignName: PropTypes.string,
  campaignDescription: PropTypes.string,
  campaignLogoURL: PropTypes.string,
  tip: PropTypes.number
}
